import React from 'react';
import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';

interface Props {
  onClickButton(): void;
}

export const EmptyCart = (props: Props) => (
  <div className="CartSidebar__empty-state">
    <h3>
      <TranslatedMessage id={'cart.empty_cart.cart_is_empty'} />{' '}
    </h3>
    <Button
      onClick={props.onClickButton}
      className="CartSidebar__button--continue-shopping"
    >
      <TranslatedMessage id={'cart.empty_cart.continue'} />
    </Button>
  </div>
);
